import { Button } from '../../ui/primitives'

/** Data locale in formato ISO, senza passare da UTC: alle 00:30 il giorno deve restare quello. */
export function isoDate(d: Date) {
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const gg = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mm}-${gg}`
}

/**
 * Scorciatoie di periodo per i filtri a data: oggi, la settimana corrente (lunedì-domenica),
 * il mese corrente, tutto. «Tutto» azzera la coppia, e il chiamante decide che cosa significa
 * (per le proposte è davvero tutte le date; per le consegne è la finestra disponibile).
 *
 * La scorciatoia attiva si riconosce dal fatto che le date correnti coincidono con le sue:
 * così resta accesa anche se l'utente ci arriva scrivendo le stesse date a mano, e si spegne
 * da sola appena le cambia.
 */
export function QuickDates({
  from,
  to,
  onChange,
  allLabel = 'Sempre',
}: {
  from: string
  to: string
  onChange: (from: string, to: string) => void
  allLabel?: string
}) {
  const oggi = new Date()

  const lunedi = new Date(oggi)
  // getDay(): domenica = 0. La settimana qui parte dal lunedì, come l'agenda del planning.
  lunedi.setDate(oggi.getDate() - ((oggi.getDay() + 6) % 7))
  const domenica = new Date(lunedi)
  domenica.setDate(lunedi.getDate() + 6)

  const primoDelMese = new Date(oggi.getFullYear(), oggi.getMonth(), 1)
  const ultimoDelMese = new Date(oggi.getFullYear(), oggi.getMonth() + 1, 0)

  const scorciatoie = [
    { label: 'Oggi', from: isoDate(oggi), to: isoDate(oggi) },
    { label: 'Questa settimana', from: isoDate(lunedi), to: isoDate(domenica) },
    { label: 'Questo mese', from: isoDate(primoDelMese), to: isoDate(ultimoDelMese) },
    { label: allLabel, from: '', to: '' },
  ]

  return (
    <div className="view-toggle" role="group" aria-label="Periodo">
      {scorciatoie.map((s) => (
        <Button
          key={s.label}
          variant={from === s.from && to === s.to ? 'primary' : 'ghost'}
          onClick={() => onChange(s.from, s.to)}
        >
          {s.label}
        </Button>
      ))}
    </div>
  )
}
